<script setup>
import { onMounted, ref } from 'vue';
import moment from "moment";
import { getRoomRunTime, getProjectWeatherData } from "@/api/common";
import { useRouter } from "vue-router";
const { currentRoute } = useRouter();
const router = currentRoute.value
let time = ref(moment(new Date()).format("MM-DD HH:mm:ss"))
let rooms = ref([]);
let weatherData = ref({})
onMounted(() => {
    setInterval(() => {
        time.value = moment(new Date()).format("MM-DD HH:mm:ss");
    }, 1000)
    getData();
    getWeatherData();
})
const getData = () => {
    getRoomRunTime(router.query.projectId).then(res => {
        if (res.success) {
            rooms.value = res.data;
            setTimeout(() => {
                getData();
            }, 24 * 60 * 60 * 1000)
        }
    })
}
const getWeatherData = () => {
    getProjectWeatherData(router.query.projectId).then(res => {
        if (res.success) {
            weatherData.value = res.data;
            setTimeout(() => {
                getData();
            }, 60 * 60 * 1000)
        }
    })
}
</script>
<template>
    <div class="flex-box flex-space-between resource-box">
        <div class="resource-header">
            <!-- <div class="header-title">
                <div class="block"></div>
                <div>冷间运行时长</div>
            </div> -->
            <div class="header-body">
                <div class="temp-hum">
                    <p class="color-orange"><span class="fz-lg">{{ weatherData.temp }}</span><span class="fz-xs">°C</span>
                    </p>
                    <p class="circle">
                        <span class="iconfont icon-caozuo-wendu color-orange"></span>
                    </p>
                    <p>温度</p>
                </div>
                <div class="temp-hum">
                    <p class="color-orange"><span class="fz-lg">{{ weatherData.humidity }}</span><span
                            class="fz-xs">%</span></p>
                    <p class="circle">
                        <span class="iconfont icon-shidu2 color-orange"></span>
                    </p>
                    <p>湿度</p>
                </div>
                <div class="timer">
                    <p><span class="iconfont icon-fuwushijian mr-5"></span> {{ time }}</p>
                    <p class="colorLG fz-lg">{{ weatherData.area }}</p>
                </div>
            </div>
        </div>
        <div class="resource-content">
            <div class="head">
                <div class="col1"></div>
                <div class="col5">冷间名称</div>
                <div class="col4">冷间运行时长</div>
            </div>
            <div class="marquee-view">
                <div class="marquee animation2">
                    <div class="row" v-for="(item, index) in rooms" :key="index">
                        <div class="col1">{{ index + 1 }}</div>
                        <div class="col5">{{ item.roomName }}</div>
                        <div class="col4 colorLG">{{ item.runTime }}分钟</div>
                    </div>
                    <div class="row" v-for="(item, index) in rooms" :key="index">
                        <div class="col1">{{ index + 1 }}</div>
                        <div class="col5">{{ item.roomName }}</div>
                        <div class="col4 colorLG">{{ item.runTime }}分钟</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.resource-box {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100% - 360px);
    margin-top: 20px;
    border: 1px solid rgba(245, 245, 245, 0.2);
}

.resource-header {
    width: 100%;
}

.header-title {
    display: flex;
    width: 100%;
    height: 40px;
    align-items: center;
    padding: 0 20px;
    background-color: rgba(108, 108, 108, 0.3);
    border-bottom: 1px solid rgba(245, 245, 245, 0.2);
    color: rgb(0, 252, 252);
    box-sizing: border-box;
    font-weight: bold;
}

.block {
    width: 10px;
    height: 10px;
    margin-right: 20px;
    background: rgb(0, 252, 252);
}

.header-body {
    display: flex;
    justify-content: space-between;
    padding: 20px 20px 0;
    box-sizing: border-box;
}

.temp-hum {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 135px;
    border-radius: 32px;
    border: 1px solid rgb(122, 122, 122);
    color: #fff;
}

.circle {
    width: 40px;
    height: 40px;
    line-height: 40px;
    margin: 10px auto;
    text-align: center;
    border-radius: 50%;
    border: 1px solid rgba(86, 86, 86, .5);

    .iconfont {
        font-size: 28px;
    }
}

.timer {
    display: flex;
    flex-direction: column;
    line-height: 3;
    margin: auto 0;
    color: #fff;
    font-weight: bold;
}

.resource-content {
    width: 100%;
    height: calc(100% - 170px);
    margin-top: 20px;
    padding: 0 4px;
    box-sizing: border-box;
}

.marquee-view {
    width: 100%;
    height: calc(100% - 56px);
    overflow: hidden;
}

.head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 50px;
    padding: 0 30px;
    color: #fff;
    font-weight: bold;
    background: rgba(228, 228, 228, 0.05);
    box-sizing: border-box;
}

.col1 {
    width: 10%;
}

.col4 {
    width: 40%;
}

.col5 {
    width: 50%;
}

.row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    padding: 0 30px;
    color: #fff;

    &:nth-child(2n-1) {
        background: rgba(195, 195, 195, 0.14);
    }
}

@keyframes row {
    0% {}

    100% {
        transform: translateY(-50%);
    }
}

.animation2 {
    animation: row 20s linear infinite;
}

.animation2:hover {
    animation-play-state: paused;
}
</style>